var m = {
  namespaced: true,
  state: {
    errorCount: 0,
    errorInfo: null
  },
  mutations: {
    /** 添加错误计数 */
    startError: function startError(state, info) {
      state.errorCount += 1;
      state.errorInfo = info;
    },

    /** 减少错误计数 */
    endError: function endError(state) {
      var count = state.errorCount;
      state.errorCount = Math.max(0, count - 1);
    }
  }
};
export default m;